import { Button, Form } from '@heroui/react'
import { validateEmail } from '@qse/constants'
import { HeroInput } from '@qse/ui'
import { ArrowLeft } from 'lucide-react'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { useForgotPassword } from '../logic'

const ForgotPasswordScreen: React.FC = () => {
  const { handleForgotPassword } = useForgotPassword()
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setIsLoading(true)

    const formData = new FormData(e.target as HTMLFormElement)
    const values = {
      email: formData.get('email') as string,
    }

    handleForgotPassword(values)
  }

  return (
    <div className="h-full">
      <div className="sticky top-0 flex justify-between w-full px-4 z-50 py-4 dark:bg-[#000] bg-white">
        <Button
          as={Link}
          className="font-medium"
          startContent={<ArrowLeft size={16} />}
          to="/auth/login"
          variant="light"
        >
          Back to Login
        </Button>
      </div>

      <div className="flex items-center h-[calc(100vh-72px)] w-full lg:pl-[110px] lg:max-w-full max-w-[440px] mx-auto">
        <div className="lg:w-[440px] w-full p-8 lg:p-0 flex flex-col gap-11">
          <div className="flex flex-col gap-2">
            <h1 className="text-[28px] font-medium">Forgot Password?</h1>
            <p className="text-[15px]">
              No worries! Enter your email address and we'll send you a code to reset your password.
            </p>
          </div>

          <Form className="w-full" validationBehavior="native" onSubmit={handleSubmit}>
            <div className="w-full">
              <div className="flex flex-col gap-[30px]">
                <HeroInput
                  isRequired
                  control="email"
                  label="Email Address"
                  name="email"
                  placeholder="Enter your email address"
                  radius="sm"
                  size="md"
                  validate={validateEmail}
                  variant="bordered"
                />
              </div>

              <Button
                className="w-full mt-6 font-medium"
                color="primary"
                isLoading={isLoading}
                radius="sm"
                type="submit"
              >
                Send Reset Code
              </Button>

              <div className="text-center mt-6">
                <span className="text-sm">
                  Remember your password?{' '}
                  <Link className="text-primary font-medium hover:underline" to="/auth/login">
                    Back to Login
                  </Link>
                </span>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordScreen
